import {Component} from '@angular/core';
import {UntypedFormArray, UntypedFormControl} from '@angular/forms';
import {MatChipInputEvent} from '@angular/material/chips';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {NgxSpinnerService} from 'ngx-spinner';
import {EMPTY} from 'rxjs';

import {PersonApiService} from '@atmi/core';
import {separatorKeysCodes} from '@atmi/core/utils';
import {BaseFormComponent, FormManagerService} from '@sim/form';

import {Person, PersonMeta} from '../../models/person';

@Component({
  selector: 'app-person-manager',
  styleUrls: ['./person-manager.component.scss'],
  templateUrl: './person-manager.component.html',
})
export class PersonManagerComponent extends BaseFormComponent<Person> {

  readonly separatorKeysCodes = separatorKeysCodes;

  get personName() {
    if (this.entityForm?.value?.nome && this.entityForm?.value?.cognome) {
      const name = `${this.entityForm.value.nome} ${this.entityForm.value.cognome}`;
      return this.entityForm?.value?.ragioneSociale ? `${name} (${this.entityForm?.value?.ragioneSociale})` : name;
    }
    if (this.entityForm?.value?.nome) {
      return this.entityForm.value.nome;
    }
    if (this.entityForm?.value?.cognome) {
      return this.entityForm.value.cognome;
    }
    if (this.entityForm?.value?.ragioneSociale) {
      return this.entityForm.value.ragioneSociale;
    }
    return '-';
  }

  constructor(
    private readonly personApi: PersonApiService,
    protected readonly formManager: FormManagerService,
    protected readonly route: ActivatedRoute,
    protected readonly snackBarService: MatSnackBar,
    protected readonly spinner: NgxSpinnerService,
    protected readonly translate: TranslateService,
  ) {
    super(
      snackBarService,
      translate,
      route,
      formManager,
      spinner,
      undefined,
      PersonMeta,
      (id) => personApi.get(id as string),
    );
  }

  addConcrete(person: Person) {
    return this.personApi.post(person);
  }

  removeConcrete(person: Person) {
    if (person.id) {
      return this.personApi.remove(person.id);
    }
    return EMPTY;
  }

  editConcrete(person: Person) {
    return this.personApi.put(person);
  }

  resetFormConcrete() {
    return EMPTY;
  }

  removeTagHandler(tagForm: UntypedFormArray, index: number) {
    if (!tagForm.controls) {
      throw new Error('Cannot manage input without a control');
    }

    tagForm.removeAt(index);
  }

  addTagHandler(tagForm: UntypedFormArray, event: MatChipInputEvent, inputTag: HTMLInputElement): void {
    const value = (event.value || '').trim();
    if (!value) {
      return;
    }
    const control = new UntypedFormControl(value);

    tagForm.push(control);

    inputTag.value = '';
  }
}
